import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: #100f12;
  padding: 40px 0;

  .content {
    max-width: 1440px;
    padding: 8em 40px 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 97%;
    flex: 1;

    @media (max-width: 1366px) {
      padding: 4em 40px 0;
    }

    .menu-list {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      margin-top: 50px;
      max-height: 450px;
      width: fit-content;

      @media (max-width: 1366px) {
        justify-content: space-evenly;
        margin: 0;
      }

      @media (max-width: 768px) {
        max-height: 100%;
      }

      a {
        font-family: 'Avenir Next LT Pro Bold';
        -webkit-text-stroke: 2px white;
        color: #100f12;
        font-size: 100px;
        letter-spacing: 0px;
        text-decoration: none;
        transition: all ease-in-out 0.4s;
        display: block;

        @media (max-width: 1366px) {
          font-size: 70px;
        }

        @media (max-width: 414px) {
          font-size: 55px;
        }

        &:hover {
          color: #fff;
        }
      }

      a.active {
        color: #fff;

        &:hover {
          -webkit-text-stroke: 2px white;
          color: #100f12;
        }
      }
    }

    .footer {
      display: flex;

      div {
        border-left: 3px solid #fff;
        padding-left: 30px;
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h4 {
          font-family: 'Avenir Next LT Pro Bold';
          font-size: 17px;
          line-height: 18px;
          margin-bottom: 12px;
        }

        ul {
          display: flex;
          a {
            text-decoration: none;
            color: #fff;
            margin-right: 20px;

            &:after {
              content: '';
              display: block;
              height: 2px;
              width: 70%;
              background: #fff;
              transition: all ease-in-out 0.3s;
            }

            &:hover {
              ::after {
                width: 100%;
              }
            }
          }
        }

        p {
          color: #fff;
        }
      }
    }
  }
`;

export const Button = styled.button`
  position: relative;
  z-index: 999;
  background: none;
  border: 0;
  width: 30px;
  height: 20px;

  span {
    display: block;
    width: 30px;
    height: 3px;
    background: #fff;

    & + span {
      width: 20px;
      margin-top: 6px;
    }
  }
`;
